import React, {Component} from 'react';
import FilterGenerateListWithImage from '../parts/FilterGenerateListWithImage';
import Axios from 'axios';
import APIENDPOINT from '../ApiEndpoint';

class DidactischPrincipe extends Component {
    constructor(props){
        super(props);
        this.state = {
            types: [],
            typesfull: [],
            filterOptions: []
        }
    }
    
    async componentDidMount(){
        const {data} = await Axios.get(`${APIENDPOINT}/types`);

        this.setState({typesfull : Object.values(data) });
    }

    findFilterOptions = (needle) => {
        if(this.state.typesfull.length > 0){
            const typeOptions = this.state.typesfull.find(type => type.type_name === needle).options;
            return typeOptions;

        }else{
            return [];
        }
    }

    render(){
        const filterOptionImages = ["img/structuur-illustratie_2x.png", "img/actief-illustratie_2x.png", "img/zelfmanagement-illustratie_2x.png", "img/samenwerking-illustratie_2x.png", "img/groeigerichtheid-illustratie_2x.png"];
        const filtersOptions = this.findFilterOptions("Didactisch Principe");
        return(
            <FilterGenerateListWithImage title='Selecteer een principe' filterOptionImages={filterOptionImages} filterOptions={filtersOptions}/>
        )
    }
}

export default DidactischPrincipe;